// extracted by mini-css-extract-plugin
export var category = "styles-module--category--ea19a";
export var layout = "styles-module--layout--bb548";
export var link = "styles-module--link--8ca6d";
export var links = "styles-module--links--018ae";
export var many = "styles-module--many--2623d";